<template>
  <b-tabs pills content-class="mt-3">
    <slot></slot>
  </b-tabs>
</template>

<script>
  export default {
    data() {
      return {}
    },
    mounted() {
      document.querySelectorAll('.show-after-load').forEach(el => {
        el.className = ''
      })
    },
  }
</script>